module.exports = __webpack_public_path__ + "static/media/3DPPA44.694c9ca1.jpg";